/* eslint-disable import/no-unresolved */
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useMutation } from 'react-query';

import MainBodyLayout from '../partials/MainBodyLayout';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import { LoyaltyContext } from '../../../../contexts/loyalty/context';
import { showAlert } from '../../../../utilities/notifications';
import { CARD_CASHBACK_CURRENCY_UPDATE } from '../../mutations';
import { loyaltyScreens } from '../../../../utilities/constants';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

const SelectCashback = () => {
  const { t: translate } = useTranslation();
  const { state, openScreen } = useContext(LoyaltyContext);
  const [dataIndex, setIndex] = useState(0);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [cashbackChangedSuccess, setCashbackChanged] = useState(false);
  const { state: locationState } = useLocation();

  const coins = Object.values(locationState?.allowedCurrencies);

  const { isUsEnv } = useUsEnv();

  const screenOptions = state?.screenOptions;
  const onPrevClick = () => openScreen(screenOptions.prevScreen);

  const { mutate: updateCashbackCurrency } = useMutation(CARD_CASHBACK_CURRENCY_UPDATE, {
    onSettled: (data, error) => {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        setCashbackChanged(!cashbackChangedSuccess);
      }
    },
  });

  useEffect(() => {
    if (cashbackChangedSuccess) {
      showAlert({
        message: translate(
          isUsEnv
            ? 'loyalty_program_manually_cashback_currency_updated_successfully_us_message'
            : 'loyalty_program_manually_cashback_currency_updated_successfully_message'
        ).replace('__CURRENCY__', selectedCurrency?.currency_display_name),
        type: 'success',
      });
      openScreen(loyaltyScreens.CLAIM_REWARD, {
        coin: selectedCurrency,
      });
    }
  }, [cashbackChangedSuccess, isUsEnv, openScreen, selectedCurrency, translate]);

  const handleOnClick = (coin) => {
    setSelectedCurrency(coin);
    updateCashbackCurrency({ cashback_currency: coin?.id });
  };

  const renderWalletItem = (coin) => (
    <div
      className="select-cashback-contaniner cursor-pointer hover-container mb-2 p-3 rounded-extra"
      key={coin?.id}
      tabIndex={-1}
      role="button"
      onKeyPress={null}
      onClick={() => handleOnClick(coin)}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <CurrencyIcon
          currencyCode={coin?.currency_display_name}
          style={{ width: '1.4rem', height: '1.4rem' }}
        />
        <div className="col-9 ms-1">
          <p>
            <b>{coin?.currency_display_name}</b>
          </p>
          <p className="text-f6 text-shadow">
            {translate(
              isUsEnv
                ? 'loyalty_program_cashback_currency_us_percent'
                : 'loyalty_program_cashback_currency_percent'
            ).replace('__PERCENT__', coin?.cashback_reward_percent)}
          </p>
        </div>
        <i
          style={{ width: '1rem' }}
          className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
          role="button"
          aria-label={coin?.currency_display_name}
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {}}
        />
      </div>
    </div>
  );

  return (
    <MainBodyLayout className="payment-select-wallet-banner-container">
      <div className="w-100 d-flex select-cashback-title mb-3">
        {locationState.cashbackData?.cashback_currency ? (
          <div
            className="modal-title d-flex cursor-pointer text-hover select-cashback-title-arrow"
            onClick={dataIndex === 0 ? onPrevClick : () => setIndex(dataIndex - 1)}
            onKeyDown={onPrevClick}
            role="presentation">
            <i className="icon icon-arrow-back-navigation text-f4 me-2" aria-label="Back" />
          </div>
        ) : null}

        {/* mobile */}
        <p className="d-block d-md-none select-cashback-title-text text-bold text-f5">
          {translate(isUsEnv ? 'loyalty_program_us_sublabel' : 'loyalty_program_sublabel')}
        </p>

        {/* browser */}
        <p className="d-none d-md-block select-cashback-title-text text-bold text-f4">
          {translate(isUsEnv ? 'loyalty_program_us_sublabel' : 'loyalty_program_sublabel')}
        </p>
      </div>

      <div className="wallet-list-loyalty my-4">{coins.map((coin) => renderWalletItem(coin))}</div>
    </MainBodyLayout>
  );
};

export default SelectCashback;
